var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class FakeApiFilesGateway {
    constructor() {
        this.files = new Set();
    }
    uploadFile(filename) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => {
                setTimeout(() => {
                    this.files.add(filename);
                    resolve();
                }, 1000);
            });
        });
    }
    deleteFile(filename) {
        return __awaiter(this, void 0, void 0, function* () {
            this.files.delete(filename);
            return Promise.resolve();
        });
    }
    getFiles() {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.resolve(Array.from(this.files));
        });
    }
}
// export const fakeApiFilesGateway = new FakeApiFilesGateway();
//# sourceMappingURL=fakeApiFilesGateway.js.map